import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeModule: '',
  activePage: '',
  activeInvestigationModule: '',
  showHeaderLoader: false,
  infoModalDetails: {
    title: '',
    content: '',
    loading: false,
  },
  approveVaspDetails: {
    vasp_id: '',
    vasp_name: '',
  },
  rejectVaspDetails: {
    vasp_id: '',
    vasp_name: '',
  },
  updateTransferModalStatus: {
    confirmed: false,
  },
  updateTransferModalData: {
    title: '',
    content: '',
  },

  isRemoveUserModalOpen: false,
  isDeleteAddressModalOpen: false,
  isDeleteAddressNoteModalOpen: false,
  isDeleteTransactionModalOpen: false,
  isDeleteTransactionNoteModalOpen: false,
  isDeleteAiDocModalOpen: false,
  isChooseKYCUploadModalOpen: false,
  isAddressHistoryModalOpen: false,
  isAddressReportModalOpen: false,
  isTransactionHistoryModalOpen: false,
  isTransactionReportModalOpen: false,
  isTransferReportModalOpen: false,
  isInfoModalOpen: false,
  isApproveVaspModalOpen: false,
  isRejectVaspModalOpen: false,
  isUpdateTransferModalOpen: false,
  isTransactionDetailsModalOpen: false,
  isExploreAccountModalOpen: false,
  isUpgradeModalOpen: false,
  isAddressSearchModalOpen: false,
  isAiDocumentUploadModalOpen: false,

  isRecordUpdated: false,
  isPageTableUpdated: false,
  isProfileUpdated: false,
  isNotifUpdated: false,

  isAppSidebarDrawerOpen: false,

  isIndividualAccountDrawerOpen: false,
  isEntityAccountDrawerOpen: false,
  isIndividualRecipientDrawerOpen: false,
  isEntityRecipientDrawerOpen: false,
  isVaspDrawerOpen: false,
  isTransferDrawerOpen: false,
  isLinkAddressDrawerOpen: false,
  isLinkTransactionDrawerOpen: false,
  isUserDrawerOpen: false,
  isRequestVaspModalOpen: false,
}

const store = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setActiveModule: (state, { payload }) => {
      state.activeModule = payload
    },
    setActivePage: (state, { payload }) => {
      state.activePage = payload
    },
    setInfoModalDetails: (state, { payload }) => {
      if (payload) {
        const { title, content, loading } = payload
        state.infoModalDetails = { title, content, loading }
      } else {
        state.infoModalDetails = { title: '', content: '', loading: false }
      }
    },
    setActiveInvestigationModule: (state, { payload }) => {
      state.activeInvestigationModule = payload
    },
    setShowHeaderLoader: (state, { payload }) => {
      state.showHeaderLoader = payload
    },
    setApproveVaspDetails: (state, { payload }) => {
      state.approveVaspDetails = payload || {
        vasp_id: '',
        vasp_name: '',
      }
    },
    setRejectVaspDetails: (state, { payload }) => {
      state.rejectVaspDetails = payload || {
        vasp_id: '',
        vasp_name: '',
      }
    },
    setUpdateTransferModalStatus: (state, { payload }) => {
      state.updateTransferModalStatus = payload || {
        confirmed: false,
      }
    },
    setUpdateTransferModalData: (state, { payload }) => {
      state.updateTransferModalData = payload || {
        title: '',
        content: '',
      }
    },
    //*
    toggleRemoveUserModal: (state) => {
      state.isRemoveUserModalOpen = !state.isRemoveUserModalOpen
    },
    toggleDeleteAddressModal: (state) => {
      state.isDeleteAddressModalOpen = !state.isDeleteAddressModalOpen
    },
    toggleDeleteAddressNoteModal: (state) => {
      state.isDeleteAddressNoteModalOpen = !state.isDeleteAddressNoteModalOpen
    },
    toggleDeleteTransactionModal: (state) => {
      state.isDeleteTransactionModalOpen = !state.isDeleteTransactionModalOpen
    },
    toggleDeleteTransactionNoteModal: (state) => {
      state.isDeleteTransactionNoteModalOpen = !state.isDeleteTransactionNoteModalOpen
    },
    toggleDeleteAiDocModalOpen: (state) => {
      state.isDeleteAiDocModalOpen = !state.isDeleteAiDocModalOpen
    },
    toggleChooseKYCUploadModal: (state) => {
      state.isChooseKYCUploadModalOpen = !state.isChooseKYCUploadModalOpen
    },
    toggleAddressHistoryModal: (state) => {
      state.isAddressHistoryModalOpen = !state.isAddressHistoryModalOpen
    },
    toggleAddressReportModal: (state) => {
      state.isAddressReportModalOpen = !state.isAddressReportModalOpen
    },
    toggleTransactionHistoryModal: (state) => {
      state.isTransactionHistoryModalOpen = !state.isTransactionHistoryModalOpen
    },
    toggleTransactionReportModal: (state) => {
      state.isTransactionReportModalOpen = !state.isTransactionReportModalOpen
    },
    toggleTransferReportModal: (state) => {
      state.isTransferReportModalOpen = !state.isTransferReportModalOpen
    },
    toggleInfoModal: (state, { payload }) => {
      if (payload !== undefined || payload !== null) {
        state.isInfoModalOpen = payload
      } else {
        state.isInfoModalOpen = !state.isInfoModalOpen
      }
    },
    setApproveVaspModal: (state, { payload }) => {
      if (payload !== undefined || payload !== null) {
        state.isApproveVaspModalOpen = payload
      } else {
        state.isApproveVaspModalOpen = !state.isApproveVaspModalOpen
      }
    },
    setRejectVaspModal: (state, { payload }) => {
      if (payload !== undefined || payload !== null) {
        state.isRejectVaspModalOpen = payload
      } else {
        state.isRejectVaspModalOpen = !state.isRejectVaspModalOpen
      }
    },
    toggleUpdateTransferModal: (state) => {
      state.isUpdateTransferModalOpen = !state.isUpdateTransferModalOpen
    },
    toggleTransactionDetailsModalOpen: (state) => {
      state.isTransactionDetailsModalOpen = !state.isTransactionDetailsModalOpen
    },
    toggleExploreAccountModalOpen: (state) => {
      state.isExploreAccountModalOpen = !state.isExploreAccountModalOpen
    },
    toggleUpgradeModal: (state) => {
      state.isUpgradeModalOpen = !state.isUpgradeModalOpen
    },
    setIsAddressSearchModalOpen: (state, { payload }) => {
      if (payload !== undefined || payload !== null) {
        state.isAddressSearchModalOpen = payload
      } else {
        state.isAddressSearchModalOpen = !state.isAddressSearchModalOpen
      }
    },
    //*
    setIsRecordUpdated: (state, { payload }) => {
      state.isRecordUpdated = payload
    },
    setIsPageTableUpdated: (state, { payload }) => {
      state.isPageTableUpdated = payload
    },
    setIsProfileUpdated: (state, { payload }) => {
      state.isProfileUpdated = payload
    },
    setIsNotifUpdated: (state, { payload }) => {
      state.isNotifUpdated = payload
    },
    //*
    openAppSidebarDrawer: (state) => {
      state.isAppSidebarDrawerOpen = true
    },
    closeAppSidebarDrawer: (state) => {
      state.isAppSidebarDrawerOpen = false
    },
    //*
    setIsIndividualAccountDrawerOpen: (state, { payload }) => {
      state.isIndividualAccountDrawerOpen = payload || false
    },
    setIsEntityAccountDrawerOpen: (state, { payload }) => {
      state.isEntityAccountDrawerOpen = payload || false
    },
    setIsIndividualRecipientDrawerOpen: (state, { payload }) => {
      state.isIndividualRecipientDrawerOpen = payload || false
    },
    setIsEntityRecipientDrawerOpen: (state, { payload }) => {
      state.isEntityRecipientDrawerOpen = payload || false
    },
    setIsVaspDrawerOpen: (state, { payload }) => {
      state.isVaspDrawerOpen = payload || false
    },
    setIsTransferDrawerOpen: (state, { payload }) => {
      state.isTransferDrawerOpen = payload || false
    },
    setIsLinkAddressDrawerOpen: (state, { payload }) => {
      state.isLinkAddressDrawerOpen = payload || false
    },
    setIsLinkTransactionDrawerOpen: (state, { payload }) => {
      state.isLinkTransactionDrawerOpen = payload || false
    },
    setIsUserDrawerOpen: (state, { payload }) => {
      state.isUserDrawerOpen = payload || false
    },
    setIsRequestVaspModalOpen: (state, { payload }) => {
      state.isRequestVaspModalOpen = payload || false
    },
    setIsAiDocumentUploadModalOpen: (state, { payload }) => {
      state.isAiDocumentUploadModalOpen = payload || false
    },
  },
})

export default store
